import { ImageContainer } from "./styles";

const ImageBackground = ({src, alt, color}) => {
    
    return(
        <ImageContainer src={src} alt={alt} />
    )
}

export default ImageBackground;